import { useCallback, useEffect, useState, RefObject } from "react";

import {
  ClickAwayListener,
  IconButtonProps,
  Tooltip as MuiToolTip,
  TooltipProps,
} from "@mui/material";

import { InfoButton } from "../../buttons";

type Props = Pick<IconButtonProps, "size" | "sx"> &
  Pick<TooltipProps, "placement"> & {
    dataTestId: string;
    tooltip: string;
    buttonRef?: RefObject<HTMLButtonElement>;
    fontSize?: number;
  };

export function Tooltip({
  buttonRef,
  dataTestId,
  tooltip,
  size = "small",
  sx,
  placement = "bottom-start",
  fontSize,
}: Props) {
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);

  const handleHelpIconClick = useCallback(() => {
    setTooltipOpen(true);
  }, []);

  const handleTooltipClose = useCallback(() => {
    setTooltipOpen(false);
  }, []);

  const drawerEl = document.querySelector(".MuiDrawer-paperAnchorBottom");

  useEffect(() => {
    const handleScroll = () => {
      if (tooltipOpen) handleTooltipClose();
    };
    drawerEl?.addEventListener("scroll", handleScroll);

    return () => {
      drawerEl?.removeEventListener("scroll", handleScroll);
    };
  }, [drawerEl, tooltipOpen]);

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <MuiToolTip
        onClose={handleTooltipClose}
        placement={placement}
        open={tooltipOpen}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        {...(fontSize && {
          slotProps: { tooltip: { sx: { fontSize: `${fontSize}px` } } },
        })}
        title={tooltip}>
        <InfoButton
          ref={buttonRef}
          className="tooltip-button"
          sx={sx}
          size={size}
          onClick={handleHelpIconClick}
          data-testid={`${dataTestId}-tooltip`}
        />
      </MuiToolTip>
    </ClickAwayListener>
  );
}
